module.exports = __webpack_public_path__ + "img/achievement-step-1-en.06e9d5db.png";